
declare global {
  interface Window {
    KiwiJSBridge: any,
    HUYASdk: any,
  }
}

/* 获取url参数 */
export const getURLParam = (name: any) => {
  const value = window.location.search.match(
    new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'),
  );
  return value ? decodeURIComponent(value[1]) : value;
}

/* 判断环境拉取数据 */
export const fetchProd: () => boolean = () => {
  const url = window.location.hostname;
  if (url === 'hd.huya.com') {
    return true;
  } else {
    if (getURLParam('test') !== null) {
      return false;
    }
    return true;
  }
}

/* 判断是否H5打开 */
export const isDeviceOpen: () => boolean = () => {
  const device = navigator.userAgent;
  const reg = RegExp(/Android|webOS|iPhone|iPod|BlackBerry/i);
  return reg.test(device);
}

/* 用户名转义 */
export const unescapeHTML = (str: string) => {
  if (str) {
    return str
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&#39;/g, "'")
  }
}


// 去直播间
export const goLive = (item: any) => {
  const isAnchor = getURLParam('source') === 'anchor'

  if (isAnchor) return
  var typeIds = { // 品类id对应原生模板
    2168: 2, // 颜值

    4079: 10, // 交友
    1663: 11 // 移动星秀
  }

  if (typeof item === 'undefined') return

  if (window.KiwiJSBridge) {
    var url = 'https://www.huya.com/page?hyaction=live&uid=' + item.lPid + '&channelid=' + item.lTid + '&subid=' + item.lSid + '&sourcetype=' + typeIds
    window.HUYASdk && window.HUYASdk.openUrl({
      url: url
    })
  } else {
    window.location.href = `https://m.huya.com/${item.iRoomId}`
  }
}